export default __webpack_public_path__ + "static/media/load.5f213b9b.gif";